import { provideRouter, Routes, withHashLocation } from '@angular/router';
import { NewIntakeComponent } from './new-intake/new-intake.component';
import { FamilyListComponent } from './family-list/family-list.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'family-list',
    pathMatch: 'full',
  },
  {
    path: 'new-intake',
    component: NewIntakeComponent,
    data: { breadcrumb: 'Patient Info' },
  },
  {
    path: 'new-intake/:id',
    component: NewIntakeComponent,
    data: { breadcrumb: 'Patient Info' },
  },
  {
    path: 'family-list',
    component: FamilyListComponent,
    data: { breadcrumb: 'Family Members' },
  },
  {
    path: '**',
    redirectTo: 'family-list',
  },
];
export const appRouting = provideRouter(routes, withHashLocation());
